import { Component, Input, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ResourceService } from 'src/app/core/services/resource.service';
import { ResourcesEndpointEnum } from 'src/app/core/enums/resources-endpoint.enum';
import { ToastrService } from 'ngx-toastr';
import { throwError } from 'rxjs';
import { EmbedConfigModel } from 'src/app/core/interfaces/Collapsable-title';
import { ReportsStore } from 'src/app/core/stores/reports.store';
import { CategoriesStore } from 'src/app/core/stores/categories.store';

@Component({
  selector: 'app-embed-dashboard-card',
  standalone: true,
  imports: [IonicModule, NgIf, TranslateModule],
  templateUrl: './embed-dashboard-card.component.html',
  styleUrls: ['./embed-dashboard-card.component.scss'],
})
export class EmbedDashboardCardComponent {
  @Input() embed!: EmbedConfigModel;
  @Input() collapsableTitle: string = '';
  @Input() collapsableTitleId: number = 0;
  @Input() hideOnUnfavorite: boolean = false;
  visible = true;

  private resourceService = inject(ResourceService);
  private translateService = inject(TranslateService);
  private toastrService = inject(ToastrService);
  private reportsStore = inject(ReportsStore);
  private categoriesStore = inject(CategoriesStore);

  @Input() returnUrl: string = '/home';

  constructor(private router: Router) {}

  private toSlug(label: string): string {
    return label.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
  }

  open() {
    if (this.embed.EmbedOption === 'newpage') {
      window.open(this.embed.Url, '_blank', 'noopener,noreferrer');
    } else {
      this.router.navigate(['/home/embed', this.toSlug(this.embed.Label)], { queryParams: { returnUrl: this.returnUrl } });
    }
  }

  setAsFavorite(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.resourceService.post<any>(
      ResourcesEndpointEnum.POST_EMBED_FAVORITE,
      null,
      { collapsableTitleID: this.collapsableTitleId, embedId: this.embed.Id }
    ).subscribe({
      next: (response: any) => {
        const updated: EmbedConfigModel = { ...this.embed, IsFavorite: response?.isFavorite };
        this.embed = updated;
        if (!updated.IsFavorite && this.hideOnUnfavorite) {
          this.visible = false;
        }
        this.reportsStore.pinnedFavorites = null;
        this.categoriesStore.categories = null;
        const key = updated.IsFavorite ? 'Added to favorites' : 'Removed from favorites';
        this.translateService.get(key).subscribe(t => this.toastrService.success(t));
      },
      error: (err) => {
        this.translateService.get('Error when toggling favorite').subscribe(t => this.toastrService.error(t));
        throwError(() => err);
      }
    });
  }
}
